import { z } from 'zod';

const validateEmail = (email: string): boolean => {
    if (/\s/.test(email)) {
        return false;
    }

    const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
};

const emailSchema = z
    .string()
    .refine((email) => validateEmail(email), {
        message: 'Email address is not valid',
    })
    .refine((email) => !/\s/.test(email), {
        message: 'Email address must not contain whitespaces',
    });

export type SenderProfile = {
    id: string;
    projectUuid: string;
    integrationId: string;
    providerId: string;
    fromEmail: string;
    fromName: string;
    replyTo: string;
    hidden: boolean;
    isDefault: boolean;
    createdBy: string;
    updatedBy: string;
};

export type SenderProfileIn = Omit<
    SenderProfile,
    'id' | 'createdBy' | 'updatedBy' | 'projectUuid' | 'hidden' | 'isDefault'
>;

export type SenderProfileUpdate = Partial<
    Pick<
        SenderProfile,
        'fromEmail' | 'fromName' | 'replyTo' | 'hidden' | 'isDefault'
    >
>;

export const SenderProfileInSchema = z.object({
    integrationId: z.string(),
    providerId: z.string(),
    fromEmail: emailSchema,
    fromName: z.string(),
    replyTo: emailSchema,
});

export const SenderProfileUpdateSchema = z.object({
    fromEmail: emailSchema.optional(),
    fromName: z.string().optional(),
    replyTo: emailSchema.optional(),
    hidden: z.boolean().optional(),
    isDefault: z.boolean().optional(),
});
